export function isDate(value) {
    // Regular expression to check if the value resembles a date
    const dateRegex = /^\d{4}-\d{2}-\d{2}/;
    return dateRegex.test(value);
  }